import React, { useState, useEffect } from "react";
import axios from "axios";
import "./VisionBlueprint.css";

function VisionBlueprint99() {
  // =====================================================
  // HIDE MAIN WEBSITE NAVBAR / FOOTER
  // =====================================================

  useEffect(() => {
    const navbars = document.querySelectorAll(
      ".navbar, nav:not(.vb99-hero nav)"
    );

    const footers = document.querySelectorAll(
      "body > footer, #root > footer"
    );

    navbars.forEach((element) => {
      element.style.display = "none";
    });

    footers.forEach((element) => {
      element.style.display = "none";
    });

    return () => {
      navbars.forEach((element) => {
        element.style.display = "";
      });

      footers.forEach((element) => {
        element.style.display = "";
      });
    };
  }, []);

  // =====================================================
  // STATES
  // =====================================================

  const [showModal, setShowModal] = useState(false);

  const [paymentSuccess, setPaymentSuccess] =
    useState(false);

  const [paymentId, setPaymentId] =
    useState("");

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
  });

  const [loading, setLoading] = useState(false);

  // =====================================================
  // WEBINAR OFFER STATUS
  // =====================================================

  const [isWebinarActive, setIsWebinarActive] =
    useState(false);

  const [offerLoading, setOfferLoading] =
    useState(true);

  // =====================================================
  // CHECK WEBINAR ACTIVE STATUS
  // =====================================================

  useEffect(() => {
    const checkWebinarStatus = async () => {
      try {
        const response = await axios.get(
  "/api/offers/vision_blueprint99"
);

        if (
          response.data?.success &&
          response.data?.offer?.isActive === true
        ) {
          setIsWebinarActive(true);
        } else {
          setIsWebinarActive(false);
        }
      } catch (error) {
        console.log(
          "Vision Blueprint is currently inactive.",
          error.response?.data?.message ||
            error.message
        );

        setIsWebinarActive(false);
      } finally {
        setOfferLoading(false);
      }
    };

    checkWebinarStatus();
  }, []);

  // =====================================================
  // OPEN ENROLL
  // =====================================================

  const openEnroll = (e) => {
    e?.preventDefault();

    // Webinar inactive / status still loading
    if (!isWebinarActive || offerLoading) {
      return;
    }

    setShowModal(true);
  };

  // =====================================================
  // CLOSE MODAL
  // =====================================================

  const closeModal = () => {
    if (!loading) {
      setShowModal(false);
    }
  };

  // =====================================================
  // FORM CHANGE
  // =====================================================

  const handleChange = (e) => {
    setForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  // =====================================================
  // PAYMENT
  // =====================================================

  const handlePayment = async (e) => {
    e.preventDefault();

    if (
      !form.name.trim() ||
      !form.email.trim() ||
      !form.phone.trim()
    ) {
      alert("Please fill all details.");
      return;
    }

    // Extra frontend protection
    if (!isWebinarActive) {
      alert(
        "The Vision Blueprint webinar is currently unavailable."
      );
      return;
    }

    if (!window.Razorpay) {
      alert(
        "Razorpay checkout is not loaded. Please refresh the page and try again."
      );
      return;
    }

    setLoading(true);

    try {
      // =================================================
      // CREATE VISION BLUEPRINT ORDER
      // =================================================

      const response = await axios.post(
        "/api/razorpay/vision-blueprint/create-order",
        {
          name: form.name.trim(),
          email: form.email.trim().toLowerCase(),
          phone: form.phone.trim(),
        }
      );

      const data = response.data;

      console.log(
        "Vision Blueprint Order Response:",
        data
      );

      if (!data.success) {
        throw new Error(
          data.message ||
            "Unable to create payment order."
        );
      }

      if (
        !data.order ||
        !data.order.id
      ) {
        throw new Error(
          "Invalid Razorpay order response."
        );
      }

      // =================================================
      // RAZORPAY OPTIONS
      // =================================================

      const options = {
        key: data.keyId,

        amount: data.order.amount,

        currency:
          data.order.currency || "INR",

        name: "Forge Your Peak",

        description:
          "The Vision Blueprint",

        order_id: data.order.id,

        prefill: {
          name: form.name.trim(),

          email:
            form.email
              .trim()
              .toLowerCase(),

          contact: form.phone.trim(),
        },

        notes: {
          service: "Vision Blueprint",
          offer: "vision_blueprint",
        },

        theme: {
          color: "#cf522f",
        },

        // =================================================
        // RAZORPAY PAYMENT SUCCESS
        // =================================================

        handler: async function (
          paymentResponse
        ) {
          try {
            console.log(
              "Razorpay Payment Response:",
              paymentResponse
            );

            // =============================================
            // VERIFY PAYMENT
            // =============================================

            const verifyResponse =
              await axios.post(
                "/api/razorpay/vision-blueprint/verify-payment",
                {
                  razorpay_order_id:
                    paymentResponse.razorpay_order_id,

                  razorpay_payment_id:
                    paymentResponse.razorpay_payment_id,

                  razorpay_signature:
                    paymentResponse.razorpay_signature,

                  customerName:
                    form.name.trim(),

                  email:
                    form.email
                      .trim()
                      .toLowerCase(),

                  customerPhone:
                    form.phone.trim(),
                }
              );

            const verifyData =
              verifyResponse.data;

            console.log(
              "Vision Blueprint Verification:",
              verifyData
            );

            // =============================================
            // VERIFICATION FAILED
            // =============================================

            if (!verifyData.success) {
              throw new Error(
                verifyData.message ||
                  "Payment verification failed."
              );
            }

            // =============================================
            // PAYMENT VERIFIED
            // =============================================

            console.log(
              "✅ Vision Blueprint payment verified successfully."
            );

            // Save payment ID
            setPaymentId(
              paymentResponse.razorpay_payment_id
            );

            // Close payment form
            setShowModal(false);

            // Stop loading
            setLoading(false);

            // Show success receipt
            setPaymentSuccess(true);
          } catch (error) {
            console.error(
              "❌ Vision Blueprint verification error:",
              error
            );

            setLoading(false);

            alert(
              error.response?.data?.message ||
                error.message ||
                "Payment verification failed. Please contact support."
            );
          }
        },

        // =================================================
        // PAYMENT MODAL CLOSED
        // =================================================

        modal: {
          ondismiss: () => {
            console.log(
              "Razorpay checkout closed."
            );

            setLoading(false);
          },
        },
      };

      // =================================================
      // RAZORPAY INSTANCE
      // =================================================

      const razorpay =
        new window.Razorpay(options);

      // =================================================
      // PAYMENT FAILED
      // =================================================

      razorpay.on(
        "payment.failed",
        function (response) {
          console.error(
            "❌ Razorpay payment failed:",
            response.error
          );

          setLoading(false);

          alert(
            response.error?.description ||
              "Payment failed. Please try again."
          );
        }
      );

      // =================================================
      // OPEN RAZORPAY
      // =================================================

      razorpay.open();
    } catch (error) {
      console.error(
        "❌ Vision Blueprint payment error:",
        error
      );

      setLoading(false);

      alert(
        error.response?.data?.message ||
          error.message ||
          "Something went wrong. Please try again."
      );
    }
  };

  // =====================================================
  // INACTIVE WEBINAR PAGE
  // =====================================================

  if (!offerLoading && !isWebinarActive) {
    return (
      <div
        className="vb99-page"
        style={{
          minHeight: "100vh",
          background: "#f7f3ea",
        }}
      >
        <section
          className="vb99-inactive-page"
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "40px 20px",
          }}
        >
          <div
            className="vb99-container"
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div
              className="vb99-inactive-card"
              style={{
                width: "100%",
                maxWidth: "620px",
                textAlign: "center",
                padding: "60px 30px",
                background: "#ffffff",
                borderRadius: "20px",
                boxShadow:
                  "0 20px 60px rgba(0,0,0,0.08)",
              }}
            >
              <div
                className="vb99-inactive-icon"
                style={{
                  fontSize: "48px",
                  marginBottom: "20px",
                }}
              >
                👁️
              </div>

              <div className="vb99-eyebrow">
                THE VISION BLUEPRINT
              </div>

              <h1
                style={{
                  margin: "0 0 16px",
                  color: "#111111",
                  fontSize:
                    "clamp(32px, 5vw, 52px)",
                }}
              >
                No Current Webinar
              </h1>

              <p
                style={{
                  margin: "0 auto 10px",
                  color: "#333333",
                  fontSize: "18px",
                  lineHeight: 1.7,
                }}
              >
                The Vision Blueprint webinar is
                currently unavailable.
              </p>

              <p
                style={{
                  margin: 0,
                  color: "#666666",
                  fontSize: "16px",
                  lineHeight: 1.7,
                }}
              >
                Please check back soon for the
                next session.
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }

  // =====================================================
  // NORMAL ACTIVE WEBINAR PAGE
  // =====================================================

  return (
    <>
      <div className="vb99-page">

        {/* =================================================
            HERO
        ================================================= */}

        <header className="vb99-hero">

          <div className="vb99-container">

            <div className="vb99-hero-top">

              <div className="vb99-brand">
                FORGE <span>YOUR PEAK</span>
              </div>

              <div className="vb99-hero-meta">
                <div>
                  The Vision Blueprint
                </div>

                <div>
                  hosted by{" "}
                  <span>Mr. Vevek</span>
                </div>
              </div>

            </div>

            <div className="vb99-chart">

              <div className="vb99-chart-line vb99-l1">
                See
              </div>

              <div className="vb99-chart-line vb99-l2">
                better
              </div>

              <div className="vb99-chart-line vb99-l3">
                starting
              </div>

              <div className="vb99-chart-line vb99-l4">
                today
              </div>

              <p className="vb99-l5">
                The Vision Blueprint — a live
                session on everyday habits for eye
                comfort, by Forge Your Peak.
              </p>

            </div>

            <div className="vb99-hero-facts">

              <div className="vb99-pill">
                📅{" "}
                <b>30 September 2026</b>
              </div>

              <div className="vb99-pill">
                🕠 <b>5:15 PM</b>
              </div>

              <div className="vb99-pill">
                🎟️ <b>₹99</b> entry
              </div>

              <div className="vb99-pill">
                🎙️ Hosted by{" "}
                <b>Mr. Vevek</b>
              </div>

            </div>

            <div className="vb99-hero-cta">

              <button
                type="button"
                className="vb99-btn"
                onClick={openEnroll}
                disabled={
                  !isWebinarActive ||
                  offerLoading
                }
              >
                {offerLoading
                  ? "Checking availability..."
                  : isWebinarActive
                  ? "Enroll now — ₹99"
                  : "Currently unavailable"}
              </button>

            </div>

            <p className="vb99-btn-sub">
              Limited seats for this live session
            </p>

          </div>

        </header>

        {/* =================================================
            SESSION CONTENT
        ================================================= */}

        <section className="vb99-section">

          <div className="vb99-container">

            <div className="vb99-section-head">

              <div className="vb99-eyebrow">
                In this session
              </div>

              <h2>
                What you'll actually walk away with
              </h2>

              <p>
                A grounded, practical hour — how
                your eyes work day to day, and simple
                habits worth building around them.
              </p>

            </div>

            <div className="vb99-covers">

              <div className="vb99-cover-item">

                <div className="vb99-aperture" />

                <div>

                  <h3>
                    How your eyes work
                  </h3>

                  <p>
                    A clear, everyday explanation of
                    what's actually going on with your
                    eyesight — no jargon, no scare
                    tactics.
                  </p>

                </div>

              </div>

              <div className="vb99-cover-item">

                <div className="vb99-aperture" />

                <div>

                  <h3>
                    A daily comfort routine
                  </h3>

                  <p>
                    A short, repeatable routine aimed
                    at easing eye strain and fatigue —
                    the kind that builds up from screens
                    and long days.
                  </p>

                </div>

              </div>

              <div className="vb99-cover-item">

                <div className="vb99-aperture" />

                <div>

                  <h3>
                    Habits for screen-heavy days
                  </h3>

                  <p>
                    Small adjustments to how you work,
                    study, and rest your eyes — the kind
                    that add up over weeks, not overnight.
                  </p>

                </div>

              </div>

              <div className="vb99-cover-item">

                <div className="vb99-aperture" />

                <div>

                  <h3>
                    Live Q&A with Mr. Vevek
                  </h3>

                  <p>
                    Bring your own questions about your
                    eyes, your routine, or your specific
                    day-to-day strain — answered live.
                  </p>

                </div>

              </div>

            </div>

          </div>

        </section>

        {/* =================================================
            SPEAKER
        ================================================= */}

        <section className="vb99-section vb99-speaker">

          <div className="vb99-container vb99-speaker-inner">

            <div className="vb99-speaker-photo">

              <img
                src="/Hero/Vevek-hero.jpeg"
                alt="Mr. Vevek"
              />

            </div>

            <div>

              <h2>
                Mr. Vevek
              </h2>

              <div className="vb99-role">
                Session host, Forge Your Peak
              </div>

              <p>
                Mr. Vevek leads Forge Your Peak's
                eye-care sessions, working with
                students, athletes, and working
                professionals on building simple,
                sustainable habits around screen time,
                strain, and everyday eye comfort.
              </p>

            </div>

          </div>

        </section>

        {/* =================================================
            TESTIMONIALS
        ================================================= */}

        <section className="vb99-section">

          <div className="vb99-container">

            <div className="vb99-section-head">

              <div className="vb99-eyebrow">
                From past sessions
              </div>

              <h2>
                What people have taken from it
              </h2>

            </div>

            <div className="vb99-quotes">

              <Quote
                text="The daily routine helped my eyes feel a lot less strained after long hours out on the field, and I finally understood what I was actually supposed to be doing to look after them."
                name="Aaditya B"
                role="22, Cricketer"
              />

              <Quote
                text="It's been four years and I still follow the habits I picked up in that one session. My eyes feel noticeably more comfortable through long work days at my desk."
                name="Aravindh"
                role="26, Engineer"
              />

              <Quote
                text="The team's guidance gave me the confidence to actually take my eye care seriously instead of ignoring it, and to stick with a routine on and off the field."
                name="Girinath Nagarajan"
                role="21, Cricketer"
              />

              <Quote
                text="I learned more about my own eyes in this one session than I had in years. Small habits, explained clearly, that made a real difference to how my eyes felt by the end of the day."
                name="Gowrisankar"
                role="27, IT Engineer"
              />

            </div>

          </div>

        </section>

        {/* =================================================
            CTA
        ================================================= */}

        <section className="vb99-section vb99-details">

          <div className="vb99-container">

            <div className="vb99-section-head">

              <div className="vb99-eyebrow">
                Join the session
              </div>

              <h2>
                The Vision Blueprint
              </h2>

              <p>
                One live session, one simple routine
                to start with.
              </p>

            </div>

            <div className="vb99-detail-grid">

              <Detail
                label="Session"
                value="Vision Blueprint"
              />

              <Detail
                label="Date"
                value="30 September 2026"
              />

              <Detail
                label="Day"
                value="Wednesday"
              />

              <Detail
                label="Time"
                value="5:15 PM"
              />

              <Detail
                label="Entry"
                value="₹99"
              />

            </div>

            <div className="vb99-final-cta">

              <button
                type="button"
                className="vb99-btn"
                onClick={openEnroll}
                disabled={
                  !isWebinarActive ||
                  offerLoading
                }
              >
                {offerLoading
                  ? "Checking availability..."
                  : isWebinarActive
                  ? "Enroll now — ₹99"
                  : "Currently unavailable"}
              </button>

              <p className="vb99-btn-sub">
                Seats are limited — hosted by
                Mr. Vevek, Forge Your Peak
              </p>

            </div>

          </div>

        </section>

        {/* =================================================
            DISCLAIMER
        ================================================= */}

        <section className="vb99-note">

          <div className="vb99-container">

            <p>
              The Vision Blueprint shares everyday
              habits for easing eye strain and building
              better screen-time routines. It's an
              educational wellness session, not a medical
              treatment, and it doesn't replace a proper
              eye examination or advice from a qualified
              eye care professional.
            </p>

          </div>

        </section>

        {/* =================================================
            FOOTER
        ================================================= */}

        <footer className="vb99-footer">
          Forge Your Peak — The Vision Blueprint,
          hosted by Mr. Vevek
        </footer>

      </div>

      {/* =================================================
          ENROLL POPUP
      ================================================= */}

      {showModal && (

        <div
          className="vb99-modal-overlay"
          onMouseDown={closeModal}
        >

          <div
            className="vb99-modal"
            onMouseDown={(e) =>
              e.stopPropagation()
            }
            role="dialog"
            aria-modal="true"
          >

            <button
              type="button"
              className="vb99-modal-close"
              onClick={closeModal}
              disabled={loading}
              aria-label="Close"
            >
              ×
            </button>

            <div className="vb99-modal-eyebrow">
              THE VISION BLUEPRINT
            </div>

            <h2>
              Reserve your seat
            </h2>

            <p className="vb99-modal-sub">
              Enter your details to continue with
              the ₹99 payment.
            </p>

            <form
              onSubmit={handlePayment}
              className="vb99-form"
            >

              {/* NAME */}

              <label>
                Name

                <input
                  type="text"
                  name="name"
                  placeholder="Enter your name"
                  value={form.name}
                  onChange={handleChange}
                  autoComplete="name"
                  required
                  disabled={loading}
                />

              </label>

              {/* EMAIL */}

              <label>
                Email

                <input
                  type="email"
                  name="email"
                  placeholder="Enter your email"
                  value={form.email}
                  onChange={handleChange}
                  autoComplete="email"
                  required
                  disabled={loading}
                />

              </label>

              {/* PHONE */}

              <label>
                Phone number

                <input
                  type="tel"
                  name="phone"
                  placeholder="Enter your phone number"
                  value={form.phone}
                  onChange={handleChange}
                  autoComplete="tel"
                  inputMode="numeric"
                  maxLength="10"
                  required
                  disabled={loading}
                />

              </label>

              {/* PAYMENT SUMMARY */}

              <div className="vb99-payment-summary">

                <span>
                  Vision Blueprint
                </span>

                <strong>
                  ₹99
                </strong>

              </div>

              {/* PAY BUTTON */}

              <button
                type="submit"
                className="vb99-pay-btn"
                disabled={loading}
              >
                {loading
                  ? "Processing..."
                  : "Pay ₹99"}
              </button>

              <p className="vb99-secure-text">
                Secure payment • Forge Your Peak
              </p>

            </form>

          </div>

        </div>

      )}

      {/* =================================================
          SUCCESS RECEIPT
          SAME STYLE AS IGNITE SUCCESS SCREEN
      ================================================= */}

      {paymentSuccess && (

        <div className="vb99-fullscreen-overlay">

          <div className="vb99-receipt-success">

            {/* ===========================================
                RECEIPT HEADER
            =========================================== */}

            <div className="vb99-receipt-header">

              <div className="vb99-receipt-check">
                ✓
              </div>

              <h2>
                Registration Successful
              </h2>

              <h3>
                The Vision Blueprint
              </h3>

            </div>

            {/* ===========================================
                ZIGZAG
            =========================================== */}

            <div className="vb99-receipt-zigzag">

              {Array.from(
                { length: 25 }
              ).map((_, index) => (
                <span key={index} />
              ))}

            </div>

            {/* ===========================================
                RECEIPT BODY
            =========================================== */}

            <div className="vb99-receipt-body">

              <div className="vb99-receipt-row">

                <span>
                  Name
                </span>

                <strong>
                  {form.name}
                </strong>

              </div>

              <div className="vb99-receipt-row">

                <span>
                  Email
                </span>

                <strong>
                  {form.email}
                </strong>

              </div>

              <div className="vb99-receipt-row">

                <span>
                  Session
                </span>

                <strong>
                  The Vision Blueprint
                </strong>

              </div>

              <div className="vb99-receipt-row">

                <span>
                  Date
                </span>

                <strong>
                  30 September 2026
                </strong>

              </div>

              <div className="vb99-receipt-row">

                <span>
                  Day
                </span>

                <strong>
                  Wednesday
                </strong>

              </div>

              <div className="vb99-receipt-row">

                <span>
                  Time
                </span>

                <strong>
                  5:15 PM
                </strong>

              </div>

              <div className="vb99-receipt-row">

                <span>
                  Amount Paid
                </span>

                <strong>
                  ₹99
                </strong>

              </div>

              <div className="vb99-receipt-divider" />

              <p className="vb99-billing-title">
                PAYMENT DETAILS
              </p>

              <div className="vb99-billing-item">
                Payment ID
              </div>

              <div className="vb99-payment-id">
                {paymentId}
              </div>

              <p className="vb99-receipt-note">
                Your registration is confirmed.
                A confirmation email has been sent
                to your registered email address.
              </p>

              <p className="vb99-receipt-note">
                Please join the session a few minutes
                early.
              </p>

              <div className="vb99-success-host">
                Hosted by{" "}
                <strong>
                  Mr. Vevek
                </strong>
                <br />
                Forge Your Peak
              </div>

            </div>

          </div>

        </div>

      )}

    </>
  );
}

/* =====================================================
   QUOTE COMPONENT
===================================================== */

function Quote({
  text,
  name,
  role,
}) {
  return (
    <div className="vb99-quote-card">

      <span className="vb99-quote-mark">
        &ldquo;
      </span>

      <p className="vb99-q">
        {text}
      </p>

      <div className="vb99-quote-who">
        <b>{name}</b> · {role}
      </div>

    </div>
  );
}

/* =====================================================
   DETAIL COMPONENT
===================================================== */

function Detail({
  label,
  value,
}) {
  return (
    <div className="vb99-detail-cell">

      <div className="vb99-k">
        {label}
      </div>

      <div className="vb99-v">
        {value}
      </div>

    </div>
  );
}

/* =====================================================
   EXPORT
===================================================== */

export default VisionBlueprint99;